export const SUNRUN_SPACE = 'iqf66370jqri';

export enum Environment {
  PROD = 'prd',
  MAJSTG = 'majstg',
  DEVMAJ = 'devmaj',
  LOCAL = 'local',
}

export const DYNAMIC_GRID_ARTICLE_LIMIT = 6;
export const DYNAMIC_SPLIT_ARTICLE_LIMIT = 4;

export enum SolarEcommHomepageEntries {
  HOMEPAGE_SUNRUN_SPACE_FOOTER = '4BLKH4utlRjsQDB0dU7bK4',
  HOMEPAGE_SUNRUN_SPACE_EMAIL_CAPTURE = '1tZtB55nxT0Ji0Rr0OHcsF',
}

export enum SolarEcommPageEntries {
  FIRST_STEP = '3zjzzPLjYwqwOgJX1HcWV8',
  SECOND_STEP = '5KFiWVpsmvCq1mjAsuJ6Eu',
  CONFIRMATION_STEP = '6bCAHwg3uWSTzYr94QfU33',
}

export enum BatteryEcommPageEntries {
  REVIEW = '5MHitMRDKRfJAZBZhbshEt',
  LOGIN = 'HFSek1fswjAr7QLin3CpU',
  QUOTE = '63itgDW3juG00sw7HxUtMg',
  END_OF_FLOW_PAGES = '3F4yGVR4FGfSKMU2MMJ2TN',
}

export enum SolarQuoteEcommPageEntries {
  QUOTE = '6EKa4YAeTBP8ZCBKZk3riB',
  CONTACT = '4GhZISZN09RCh6qqzmlnq2',
}

export const GQL_CONTENTFUL_URL = `https://graphql.contentful.com/content/v1/spaces/${SUNRUN_SPACE}/environments/master`;
